import { LeadServiceN } from './../../../../leads-v2/services/lead.service';
import { AccountServiceN } from './../../../../accounts-v2/services/account.services';
import { FilterInColumn, GelAllAccountRequestModel } from './../../../../accounts-v2/models/account-request.model';
import { GridState } from './../../../../accounts-v2/models/gridState.model';
import { AccountHelper } from './../../../../accounts-v2/services/accounts.helper';
import { SharedColumnSettingsService } from 'src/app/modules/shared/services/column-settings.service';
import { ColumnSettingsN, SectionN } from 'src/app/modules/shared/models/column-settings.model';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from "@angular/core";
import { MessageService, LazyLoadEvent } from "primeng/api";
import { AppMainService } from "../../../../app-main.service";
import { Subscription, Subject } from 'rxjs';
import { getSectionWiseFlatCols } from '../../helpers/section-wise-cols.helper';
import { Fields } from '../../models/column-settings.model';
import { ConfigDefaultService } from '../../services/configuration-default.service';
import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';
import { ImportserialService } from '../../services/importserial.service';
@Component({
    selector: 'app-shared-manual-modal',
    styleUrls: ['./app.manual.modal.component.scss'],
    templateUrl: './app.manual.modal.component.html',
})
export class AppManualModalComponent implements OnChanges, OnDestroy {

    subscription: Subscription = new Subscription();
    private ngUnsubscribe = new Subject<void>();
    displaySettings: boolean = false;

    selectedObject: any;
    selectedTemplate: any;
    selectedItemInEdit: any;
    globalFilterInputBS = '';
    selectedAccountbind = [];
    colLists = [];
    allAccounts = [];
    lsttotalRecords: number=1;
    pageSize: number = 15;
    pageNumber: number = 1;
    totalPages: number = 0;
    firstPage: number = 0;
    first: number = 0;
    tableShowMore: number[] = [15, 30, 50, 100];
    displayColSetting = false;
    tempColSetting;
    maxNoCol = false;
    totalColAmt = 0;
    savedAccountListCols: Fields[] = [];
    accountSettings=[];
    totalAmt = 0;
    maxNo = false;
    leadStages = [];

    displayColumnSettings: boolean = false;
    selectedStoreIds : any[] = [];

    //new account or lead filtter
    listColsAll: Fields[] = [];
    filterInColumns: FilterInColumn[] = [];
    selectedColumn: string[] = [];
    selectedFilterModule: any;
    appliedFilterColName: string[] = [];
    disabledLabelNames: string[] = [];

    mergeAccountSequenceNumber: boolean = false;
    accountTreeViewEnabled: boolean = true;
    expandedRows: any = [];
    noAccountFindOrLoadingText = 'Loading....';
    phoneFields: string[] = ['workphone','contactphonemobile', 'contactphonework', 'contactphonehome', 'contactphonecp1', 'contactphonecp2'];
    maximumFractionDigits: number = 2;

    constructor(
        public appMainService: AppMainService,
        private messageService: MessageService,
        private columnSettingsService: SharedColumnSettingsService,
        private accountHelper: AccountHelper,
        private accountServiceN: AccountServiceN,
        private leadServiceN: LeadServiceN,
        private configDefaultService: ConfigDefaultService,
        private importserialService: ImportserialService,

    ) {
        this.filterMatchModes = [
            {
                name: 'Starts with',
                value: 'starts_with'
            },
            {
                name: 'Contains',
                value: 'contains'
            },
            {
                name: 'Not contains',
                value: 'not_contains'
            },
            {
                name: 'Ends with',
                value: 'ends_with'
            },
            {
                name: 'Equals',
                value: 'equals'
            },
            {
                name: 'Not Equals',
                value: 'not_equals'
            }
        ]
        this.selectedFilterMode = this.filterMatchModes[0];
        this.getDefaultSettings();
     }

    @Input() displayPopup: boolean = false;
    @Input() showActiveInActive: boolean = false;
    @Input() selectedObjectType: any;
    @Input() selectedTemplateType: any;
    @Input() selectedAccount: any = [];
    @Input() selectedItem:any=[];
    @Input() colsList: Partial<ColumnSettingsN> = {};
    @Input() accountPhoneConfig = [];
    @Input() accountEmailConfig = [];
    @Input() accountSocialConfig = [];
    @Input() selectedCountry = null;
    @Input() selectedParentTerritory = null;
    @Input() source: string;
    @Input() viewOnly: boolean = false;
    @Input() singleSelection: boolean = false;
    @Input() headerTitle: string = "Data Lists";
    @Input() isActive: boolean = true;
     /**accountList Payload for Product Visibility**/
    @Input() fromProductVisibilityModule : boolean = false;
    @Input() preview : boolean = false;
    @Input() fromRule: boolean = false;
    @Input() ruleList: SavedSearchNS.IRuleList[] = [];


    @Output() saveAssignDataclicked = new EventEmitter();
    @Output() cancelClicked = new EventEmitter();
    @Output() saveSettingClicked = new EventEmitter();
    @Output() backToModuleClicked = new EventEmitter();

    currentColumnSettingName = '';
    currentTemplateId: number = 0;
    currentChannelId: number = 0;
    currentObjectId = null;
    currentColumnSettingsConfig = null;
    currentAllColumnSettings = [];
    currentSetting: any = null;
    currentSelectedCountry = null;
    currentSelectedParentTerritory = null;
    currentModuleName = '';
    currentColList: Partial<ColumnSettingsN> = {};
    currentSelectedView = '';
    currentDiplayValue = false;
    currentAccountPhoneConfig = [];
    currentAccountEmailConfig = [];
    currentAccountSocialConfig = [];
    availableViews = [];
    showConfigureEmailButton: boolean = false;
    tempCols=[];
    searchControl = new FormControl();
    gridState: GridState = new GridState();

    filterMatchModes = [];
    selectedFilterMode: string = '';
    selectedStore: boolean = false;

    /**accountList Payload for Product Visibility**/
    accountPayLoad: string = '';

    ngOnDestroy(){
        this.subscription?.unsubscribe();
        this.ngUnsubscribe?.next();
        this.ngUnsubscribe?.complete();
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (changes.selectedObjectType && changes.selectedObjectType.currentValue) {
            this.selectedObject = changes.selectedObjectType.currentValue;
            this.mergeAccountSequenceNumber = !!(this.selectedObject?.name=='Account');
        }

        if (changes.selectedTemplateType && changes.selectedTemplateType.currentValue) {
            this.selectedTemplate = changes.selectedTemplateType.currentValue;
        }

        if (changes.displayPopup && changes.displayPopup.currentValue != undefined) {
            if(this.fromProductVisibilityModule){
                this.currentDiplayValue = changes.preview.currentValue;
            }else{
              this.currentDiplayValue = changes.displayPopup.currentValue;
            }
        }

        if (changes.selectedItem && changes.selectedItem.currentValue) {
            this.selectedAccountbind = changes.selectedItem.currentValue.map(obj =>{
                //while edit
                if(obj.objectRefRecordId){
                    if(this.selectedObject.name =='Account'){
                        return obj.account;
                    } else{
                        return obj.lead;
                    }
                }
                //while add
                return obj;
            })
        }

        if (changes.selectedAccount && changes.selectedAccount.currentValue) {
            this.selectedAccountbind = changes.selectedAccount.currentValue;
        }

        if (changes.selectedCountry && changes.selectedCountry.currentValue) {
            this.currentSelectedCountry = changes.selectedCountry.currentValue;
        }
        if (changes.selectedParentTerritory && changes.selectedParentTerritory.currentValue) {
            this.currentSelectedParentTerritory = changes.selectedParentTerritory.currentValue;
        }

        if (changes.colsList && changes.colsList.currentValue) {
            this.currentColList = changes.colsList.currentValue;
            this.listColsAll =this.accountHelper.getSectionWiseFlatCols(changes.colsList.currentValue?.listViewSections||[]);
            this.setGridListColsForAccount(this.currentColList)

        }
        if (changes.accountPhoneConfig && changes.accountPhoneConfig.currentValue) {
            this.currentAccountPhoneConfig = changes.accountPhoneConfig.currentValue;
        }
        if (changes.accountEmailConfig && changes.accountEmailConfig.currentValue) {
            this.currentAccountEmailConfig = changes.accountEmailConfig.currentValue;
        }
        if (changes.accountSocialConfig && changes.accountSocialConfig.currentValue) {
            this.currentAccountSocialConfig = changes.accountSocialConfig.currentValue;
        }

         /**accountList Payload for Product Visibility**/
        if (changes.fromProductVisibilityModule?.currentValue && changes.fromRule?.currentValue && changes.ruleList?.currentValue) {
            this.filterInColumns = changes.ruleList.currentValue;
        }

        this.selectedFilterModule = {name: this.selectedObject?.name, objectId:this.selectedObject?.id, channelId: this.selectedTemplateType?.id};
        this.searchAccounts();
        this.setFractionDigits();
    }

    searchAccounts() {
        this.searchControl.valueChanges.pipe(
            debounceTime(700),
            distinctUntilChanged())
            .subscribe(value => {
                this.globalFilterInputBS = value.trim() ? value.trim() : '';
                this.onGlobalRouteStoreSearch();
            });
    }

    setFractionDigits(){
        this.importserialService.getDecimalValue().subscribe(value=>{
            this.maximumFractionDigits = value||this.maximumFractionDigits;
        });
    }

    showSetting(){
        this.displayColumnSettings = true;
    }

    setGridListColsForAccount(columnSettings: Partial<ColumnSettingsN>, change: boolean = false){
        this.savedAccountListCols = columnSettings?.listViewSections?.length ? getSectionWiseFlatCols(columnSettings.listViewSections) : [];

        if(!(change || this.fromProductVisibilityModule))
        this.getAllSelectedObjectData(1, 15);
    }

    getFlatCols(colArr: SectionN[]) {
        let fieldArr = [];
        colArr.map(element => {
            fieldArr = fieldArr.length ? [...fieldArr, ...element.fields] : [...element.fields];
        });
        return fieldArr;
    }


    onGlobalRouteStoreSearch() {
        this.refreshPagination();
        this.getAllSelectedObjectData(1, 15,null,false,false);
    }

    // Get All Accounts Listing
    getAllSelectedObjectData(currentPageNumber: number = 1, currentPageSize: number = 15, src?, isLoadStage: boolean = true, fromUpdateSettings?: boolean): void {

        if((this.savedAccountListCols?.length||0)==0) return;

        let pageNumber = currentPageNumber ? currentPageNumber : 1;
        this.pageNumber = pageNumber;
        this.pageSize = currentPageSize;

        const options: any = {};

        // Apply Sorting
        if (this.gridState && this.gridState['sort']) {
            options.sort = {
                SortBy: fromUpdateSettings ? null : this.gridState['sort'].field,
                IsAscending: this.gridState['sort'].order === 1 ? true : false
            }
        }

        options.isActive = this.isActive;
        options.moduleSearchValue = this.globalFilterInputBS.trim() || '';

        const selectableColumns: any[] = [];

        if (this.savedAccountListCols.length > 0) {
            this.savedAccountListCols.forEach((obj) => {
                if (obj.enabled) {
                    selectableColumns.push(
                        {
                            columnName: obj.columnName,
                            isCustom: obj.isCustom
                        }
                    )
                }
            });
        }
        this.selectedColumn = selectableColumns;
        const sortByColumn = this.savedAccountListCols.find(fld=> fld.columnName==options?.sort?.SortBy);
        this.selectedStoreIds = this.selectedAccountbind.map(item => item?.id);

        const mainCustomerField = this.savedAccountListCols.find(fld=> fld.columnName=='mainCustomer');
        if(mainCustomerField){
            selectableColumns.push({
                columnName: 'parentAccountSequenceNumber',
                isCustom: false
            })
        }
        
        const isCountryIdPresent = selectableColumns?.some(col => col.columnName === 'countryId');
        if (!isCountryIdPresent) {
            selectableColumns.push({
                columnName: 'countryId',
                isCustom: false
            });
        }

        const requestModel: any = {
            Ids: (this.selectedStore || (this.fromProductVisibilityModule && this.viewOnly)) ? this.selectedStoreIds : [],
            channelId: this.selectedTemplate.id,
            stageId: null,
            isActive: this.isActive,
            globalSearchValue: this.globalFilterInputBS.trim() || '',
            selectableColumns: selectableColumns,
            filter: null,
            pageSize: currentPageSize,
            pageNumber: currentPageNumber,
            sortByColumn: options?.sort?.SortBy || null,
            sortByColumnDataType: sortByColumn?.fieldDataType,
            isSortByDescending: !options?.sort?.IsAscending,
            filterInColumns: this.filterInColumns,
            countryId: this.currentSelectedCountry?.id||null,
            territoryId: this.currentSelectedParentTerritory?.id||null,
            includeChildAccounts: !this.accountTreeViewEnabled,
            includeClosedLeads: true
        }

        if (this.filterInColumns && this.filterInColumns.length > 0 && requestModel) {
            this.filterInColumns.forEach((obj) => {
                let found = requestModel?.selectableColumns.find((item)=>{
                    return item?.columnName == obj?.name;
                });
                if(!found){
                    requestModel?.selectableColumns.push(
                        {
                            columnName: obj?.name,
                            isCustom: obj?.isCustom || false
                        }
                    );
                }
            });
        }

        if(this.selectedObject.name =="Account"){
            this.appMainService.isShowSpinner('getAccountList');

            const defaultSortColumn = !this.accountTreeViewEnabled ? 'accountIdForSorting' : null;
            const sortByColumnDataType = !this.accountTreeViewEnabled ? 'Number' : null;

            requestModel.sortByColumn = requestModel.sortByColumn||defaultSortColumn;
            requestModel.sortByColumnDataType = requestModel.sortByColumnDataType||sortByColumnDataType;

            let accountListCalling = this.selectedStore ? this.accountServiceN.getAccountPagetListByIds(requestModel) : this.accountServiceN.getAccountsListWithFilters(requestModel);
              /**accountList Payload for Product Visibility**/
              if(this.fromProductVisibilityModule && this.fromRule){
                this.accountPayLoad = JSON.stringify(requestModel);
              }
             accountListCalling.pipe(takeUntil(this.ngUnsubscribe))
                .subscribe({
                    next: (response) => {
                        if (response) {
                            this.allAccounts = response?.list || [];
                            this.setEmptyAccountColor(this.allAccounts);
                            this.updateSelectedList(this.allAccounts);
                            this.lsttotalRecords = response?.totalNumberOfRows;
                            this.appMainService.isHideSpinner('getAccountList');
                            if(!this.preview && this.fromRule){
                                this.preview = true;
                                this.saveAssignDataModal();
                            }
                        }
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error!',
                            detail: 'Error occurring when loading accounts. Please try after sometime.'
                        });
                        this.appMainService.isHideSpinner('getAccountList');
                    },
                    complete: () => {

                    }
                })
        }else{
            this.appMainService.isShowSpinner('getAllLeads');
            let leadListCalling = this.selectedStore ? this.leadServiceN.getLeadPagetListByIdsWithFilter(requestModel) :   this.leadServiceN.getLeadListWithFilters(requestModel);

            leadListCalling.pipe(takeUntil(this.ngUnsubscribe))
                .subscribe({
                    next: (response) => {
                        if (response) {
                            this.allAccounts = response?.list || [];
                            this.lsttotalRecords = response?.totalNumberOfRows;

                            this.appMainService.isHideSpinner('getAllLeads');
                        }
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error!',
                            detail: 'Error occurring when loading leads. Please try after sometime.'
                        });
                        this.appMainService.isHideSpinner('getAllLeads');
                    },
                    complete: () => {

                    }
                })
        }
    }

    // Fired when there is any change on Table
    async getAllAccountsWithPagination(event?: LazyLoadEvent): Promise<void> {
        if (event) {
            this.pageSize = event.rows;
            this.pageNumber = (event.first / event.rows) + 1;

            if (event.sortField) {
                const temp = {
                    field: event.sortField,
                    order: event.sortOrder
                };

                this.gridState['sort'] = temp;
            }

            if (event.filters) {
                this.onFilterChange(event);
            }
        }
        else {
            this.pageSize = 15;
            this.pageNumber = 1;
        }

        this.getAllSelectedObjectData(this.pageNumber, this.pageSize, null, false,false);
    }

    onFilterChange(event): void {
        const filters = [];

        for (const filterName in event.filters) {
            filters.push({
                field: filterName,
                value: event.filters[filterName].value,
                matchMode: event.filters[filterName].matchMode
            });
        }

        this.gridState['filters'] = filters;
    }

    refreshPagination() {
        this.firstPage = 0;
    }

    loadListingWithFilters(){
        this.firstPage = 0;
        this.getAllSelectedObjectData(1, this.pageSize,null,false, false);
    }

    onSingleRowSelect($event: any){
        if(this.singleSelection){
            this.selectedAccountbind = [$event.data];
            this.saveAssignDataModal();
        }
    }

    saveAssignDataModal() {
        this.refreshPagination();
        this.saveAssignDataclicked.emit({
            selectedReccords: [... new Set(this.selectedAccountbind)],
            listCols: this.savedAccountListCols,
            leadStages:this.leadStages,
            accountPayLoad: (this.fromProductVisibilityModule && this.fromRule) ? this.accountPayLoad : ''
        })
    }
    cancelManualPopup(){
        this.refreshPagination();
        this.cancelClicked.emit()
        this.savedAccountListCols = this.savedAccountListCols.map(col => {
            col.value = '';
            return col;
          });
    }

    getColumnSettings(fromUpdateSettings = false): void {
        this.appMainService.isShowSpinner('getColumnSettings');
        this.subscription.add(this.columnSettingsService.getColumnSettings(this.selectedObject.id, this.selectedTemplate?.id).subscribe(
            {
                next: (response) => {
                    this.currentColList = response || {};
                    this.saveSettingClicked.emit(this.currentColList);
                    this.setGridListColsForAccount(this.currentColList)
                    this.appMainService.isHideSpinner('getColumnSettings');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getColumnSettings');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                    });
                },
                complete: () => {

                },
            }));
    }

    savedColumnSettings(data:{updatedColumnSettings:any,updateColumnSettingsData:any}): void {
        this.displayColumnSettings = false;
        this.currentColList = data?.updatedColumnSettings || {};
        this.saveSettingClicked.emit(this.currentColList);
        this.setGridListColsForAccount(this.currentColList);
    }

    backToModule(): void {
        this.backToModuleClicked.emit();
    }


    cancelColumnSettings(): void {
        this.displayColumnSettings = false;
    }

    onAssignedCheckboxChange(){
        this.getAllSelectedObjectData(1, 15);
    }


    applyFilters(event: { selectedFilter: FilterInColumn[] }) {
       this.filterInColumns = event?.selectedFilter||null;
       this.first = 0;
       this.appliedFilterColName = (event?.selectedFilter ?? []).map((sf => sf.name));
       this.disabledLabelNames = [...new Set([...this.appliedFilterColName])];
       //this.selectedFilterModule = { name: this.selectedObject.name, objectId: this.selectedObject.id, channelId: this.selectedTemplateType?.id};
       this.getAllSelectedObjectData(1, this.pageSize,null,false, false);
    }

    updateSelectedList(accountList: any[]){
        this.selectedAccountbind?.map((element, index) => {
            const exist = accountList.find(x => x.id === element.id);
            if (exist) {
                this.selectedAccountbind[index] = exist;
            }
        });
    }

    async getDefaultSettings(){
        // this.configDefaultService.getMergeAccountSequenceNumber().then(response=>{
        //     this.mergeAccountSequenceNumber = response?.enabled||false;
        // });

        const accountTreeView = await this.configDefaultService.getAccountTreeViewSettings();
        this.accountTreeViewEnabled = !accountTreeView || (accountTreeView && accountTreeView?.enabled);
    }

    onExpandRow(parentId, parent, expanded, rowColor: string = "") {
        parent.viewDetails = !expanded;
        this.expandedRows[parentId] = !expanded;

        const options: any = {};
        const fromUpdateSettings = false;

        // Apply Sorting
        if (this.gridState && this.gridState['sort']) {
            options.sort = {
                SortBy: fromUpdateSettings ? null : this.gridState['sort'].field,
                IsAscending: this.gridState['sort'].order === 1 ? true : false
            }
        }

        options.isActive = this.isActive;
        options.moduleSearchValue = this.globalFilterInputBS.trim() || '';

        if (!(parent.childAccount && parent.childAccount.length > 0)) {

            const requestModel: GelAllAccountRequestModel = {
                channelId: this.selectedTemplateType?.id,
                stageId: null,
                isActive: this.isActive,
                globalSearchValue: parentId>0 ? '' : this.globalFilterInputBS.trim() || '',
                selectableColumns: this.selectedColumn,
                filter: null,
                pageSize: 0,
                pageNumber: 0,
                sortByColumn: options?.sort?.SortBy || null,
                isSortByDescending: !options?.sort?.IsAscending,
                filterInColumns: parentId>0 ? [] : this.filterInColumns,
                parentAccountId: parentId
            }

            this.appMainService.isShowSpinner('getAccountByParentId');
            this.accountServiceN.getAccountsList(requestModel)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe({
                    next: (response) => {
                        if (response) {
                            parent.childAccount = response?.list||[];
                            parent.viewDetails = true;
                            this.expandedRows[parentId] = true;
                            this.getExpandedRows(parent.childAccount, parent, rowColor);
                        }
                        this.noAccountFindOrLoadingText = '';
                        this.appMainService.isHideSpinner('getAccountByParentId');
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('getAccountByParentId');
                        this.noAccountFindOrLoadingText = 'No accounts found.';
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error!',
                            detail: 'Error occurring when loading accounts. Please try after sometime.'
                        });
                    },
                    complete: () => {

                    }
                })

        }
    }

    getExpandedRows(list, parent: any, rowColor: string): void {
        list.forEach(element => {
            element.viewDetails = false;
            element.childLevel = (parent?.childLevel||0)+1;
            element.rowColor = rowColor;
            if (element.hasChildAccounts) {
                this.expandedRows[element.id] = false;
            }
        });
    }

    setAccountRowColor(accountList: any[], parentAccountId: number, rowColor: string){
        const childAccounts = accountList.filter(account=> account.parentAccountId==parentAccountId);
        if(childAccounts?.length>0){
            childAccounts.map(account=>{
                account.rowColor = rowColor;
                this.setAccountRowColor(accountList, account.id, rowColor);
            });
        }
    }

    findParentAccountInCurrentPage(accountList: any[], parentId: number, accountDetails: any): any | null {
        if(!parentId) return accountDetails;
        const parentAccount = accountList.find(account=> account.id==parentId);
        if(parentAccount){
            return this.findParentAccountInCurrentPage(accountList,parentAccount?.parentAccountId, parentAccount);
        }
        return accountDetails;
    }

    setEmptyAccountColor(accountList: any[]){
        accountList.map(account=>{
            account.viewDetails = false;
            this.expandedRows[account.id] = false;
            const findIndex = accountList.findIndex(accountDetails=> accountDetails.id==account.id);
            if(findIndex>=0 && !account?.rowColor){
                const preAdjacents = accountList.slice(0, findIndex).reverse();
                const postAdjacents = accountList.slice(findIndex, (accountList.length-1));

                let rowColorAccount = preAdjacents.find(account=> account?.rowColor);

                if(!rowColorAccount){
                    rowColorAccount = postAdjacents.find(account=> account?.rowColor);
                }

                if(rowColorAccount?.parentAccountId && (rowColorAccount?.parentAccountId==account?.parentAccountId)){
                    account.rowColor = rowColorAccount?.rowColor;
                }else{
                    account.rowColor = rowColorAccount?.rowColor=='child-color1' ? 'child-color2' : 'child-color1';
                }

                if(account?.parentAccountId){
                    const parentAccount = this.findParentAccountInCurrentPage(accountList, account?.parentAccountId, account);
                    parentAccount.rowColor = account?.rowColor;
                    this.setAccountRowColor(accountList, parentAccount.id, account?.rowColor);
                }else{
                    this.setAccountRowColor(accountList, account.id, account?.rowColor);
                }

            }
        });
    }

}
